.field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.label {
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--text-secondary);
}

.input {
  min-height: 48px;
  padding: 0 14px;
  background: var(--bg-elevated);
  border: 1px solid var(--border-primary);
  border-radius: 0;
  color: var(--text-primary);
  transition: border-color var(--dur-fast) var(--ease-out);
}

.input:hover {
  border-color: var(--text-muted);
}

.input:focus-visible {
  border-color: var(--accent);
  outline-offset: 0;
}

.hint {
  margin: 0;
  font-size: 0.8125rem;
  color: var(--text-muted);
}
